import { AxiosResponse } from 'axios'
import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface SlotRestrictions {
  restrictions: string[]
}

export async function getSlotRestriction(professionalUsername: string, slotId: number): Promise<AxiosResponse<SlotRestrictions>> {
  return await axios.get<SlotRestrictions>(apiEndpoints.AGENDA_RESTRICTIONS(professionalUsername, slotId))
}